import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { createDataGridFilters } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useYesNoDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';

const RIGHT_PANEL = 2;
const BOTTOM_PANEL = 4;
const DISPLAY_TRUE = 1;
const DISPLAY_FALSE = 0;

const BlocksTable = ({ blocks, onDelete, onDetailClick }) => {
  const { t } = useTranslation();
  const labelSkTextFilterProps = useDataGridTextFilter('label_sk');
  const labelEnTextFilterProps = useDataGridTextFilter('label_en');

  const displayEnProps = useYesNoDataGridFilter('display_en');
  const displaySkProps = useYesNoDataGridFilter('display_sk');

  const displayTranslations = useMemo(
    () => ({
      [DISPLAY_TRUE]: t('Áno'),
      [DISPLAY_FALSE]: t('Nie'),
    }),
    [t],
  );

  const positionTranslations = useMemo(
    () => ({
      [RIGHT_PANEL]: t('Pravý panel'),
      [BOTTOM_PANEL]: t('Spodný panel'),
    }),
    [t],
  );

  const columns = useMemo(
    () => [
      {
        title: t('Názov (slovensky)'),
        dataIndex: 'label_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('label_sk'),
        defaultSortOrder: 'ascend',
        ...labelSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'label_en',
        ellipsis: true,
        sorter: dataGridTextSorter('label_en'),
        ...labelEnTextFilterProps,
      },
      {
        title: t('Pozícia v slovenskej verzii'),
        dataIndex: 'position_sk',
        render: (position) => positionTranslations[position],
        filters: createDataGridFilters(positionTranslations),
        onFilter: (value, record) => record['position_sk'] == value,
        width: 150,
      },
      {
        title: t('Pozícia v anglickej verzii'),
        dataIndex: 'position_en',
        render: (position) => positionTranslations[position],
        filters: createDataGridFilters(positionTranslations),
        onFilter: (value, record) => record['position_en'] == value,
        width: 150,
      },
      {
        title: t('Zobraziť v slovenskej verzii'),
        dataIndex: 'display_sk',
        render: (display) => displayTranslations[display],
        ...displaySkProps,
      },
      {
        title: t('Zobraziť v anglickej verzii'),
        dataIndex: 'display_en',
        render: (display) => displayTranslations[display],
        ...displayEnProps,
      },
    ],
    [
      t,
      labelSkTextFilterProps,
      labelEnTextFilterProps,
      positionTranslations,
      displayTranslations,
    ],
  );

  return (
    <>
      <DataGrid
        rowKey={(block) => block.id}
        columns={columns}
        dataSource={blocks || []}
        permissionsBasic={'blocks'}
        uniqueTableId={'blocks-table'}
        onRowClick={onDetailClick}
        onEditClick={onDetailClick}
        onDelete={onDelete}
      />
    </>
  );
};

BlocksTable.propTypes = {
  blocks: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
  onCreateClick: PropTypes.func,
};

export default BlocksTable;
